import React from 'react';
// Import only Routes and Route, as the Router is now in index.js
import { Routes, Route } from 'react-router-dom';
import TextileSlingLanding from './components/TextileSlingLanding';
import './App.css';

/**
 * Main application component that defines the page routing structure.
 * @return {React.ReactElement} The root App component.
 */
function App() {
  return (
    // The <Router> wrapper has been removed.
    // The router in src/index.js now controls the application's routing.
    <div className="App">
      <Routes>
        {/*
          This setup defines that when a user visits the root URL ('/'),
          the TextileSlingLanding component will be rendered. This is perfect
          for a single-page landing application.
        */}
        <Route path="/" element={<TextileSlingLanding />} />
      </Routes>
    </div>
  );
}

export default App;
